import callApiAxiosClient from '../../axios/axios_client';
import { GetReportListResponse } from '../../models';

function getReportsList(): Promise<GetReportListResponse> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<GetReportListResponse>({
    method: 'get',
    url: 'media/report',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
  });
}
export default getReportsList;
